import React, { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Envelope, Telephone, Map } from 'react-bootstrap-icons';
import status from '../resources/status.json';

const MidBar = () => {
  const isSunday = new Date().getDay() === 0;
  const openStatus = isSunday ? 'Closed' : status.status;
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const navbarStyle = {
    backgroundColor: '#024621',
    minHeight: '5px',
    '--bs-navbar-padding-y': '0',
    '--bs-navbar-color': '#fff',
    '--bs-navbar-disabled-color': '#fff',
    'marginTop': '-10px',
    background: '#024621',
    overflow: 'hidden'
  };

  const iconStyle = {
    marginRight: '5px',
  };

  const latestTagStyle = {
    backgroundColor: '#FFC543',
    color: '#fff',
    padding: '2px 10px',
    borderRadius: '3px',
    fontWeight: 'bold',
    fontSize: '12px',
    marginLeft: '10px',
    display: 'inline-block'
  };

  const animatedTextStyle = {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    animation: 'scroll-left 15s linear infinite',

    color: '#fff',

  };

  const animationKeyframes = `
    @keyframes scroll-left {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(-100%);
      }
    }
  `;

  return (
    <>
      <style>{animationKeyframes}</style>
      <Navbar style={navbarStyle} variant="dark">
        <Container>
          <Nav className="me-auto">
            {isMobile ? (
              <>
                <Nav.Link >
                  {/* <Envelope style={iconStyle} size={20} /> */}
                </Nav.Link>
                <Nav.Link >
                  {/* <Telephone style={iconStyle} size={20} /> */}
                </Nav.Link>
                <Nav.Link >
                  {/* <Map style={iconStyle} size={20} /> */}
                </Nav.Link>
              </>
            ) : (
              <>
                <Nav.Link href="mailto:collegecalcuttagirls@gmail.com">
                  {/* <Envelope style={iconStyle} size={20} /> */}

                </Nav.Link>
                <Nav.Link href="tel:+1234567890">
                  {/* <Telephone style={iconStyle} size={20} /> */}
                </Nav.Link>
                <Nav.Link href="https://www.google.com/maps">
                  {/* <Map style={iconStyle} size={20} /> */}

                </Nav.Link>
              </>
            )}
          </Nav>
          <Nav>
            <div style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}>
              <span style={animatedTextStyle}>
                College is {openStatus} Today | Online Admission 2026 ||
                For more info visit Admission portal ||{' '}
                <a
                  href="https://wbcap.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: '#fff',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                 Click Here
                </a>
              </span>
            </div>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default MidBar;